import React, { useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';

import Paper from './Paper';
import { createUseStyles } from 'react-jss';
import BackgroundImage from './BackgroundImage';
import { Product } from '../types';
import Text from './Text';
import { calculateDiscount } from '../lib/utils';
import clsx from 'clsx';
import AddToCartModal from './AddToCartModal';
import Button from './Button';
import { FaCartPlus } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { reaction } from '../services/productService';
import { link } from 'fs';
import { track } from '../services/mixpanelService';

export interface ProductCardProps {
  product: Product;
  className?: string;
  trackName?: string;
}
const ProductCard: React.FC<ProductCardProps> = ({ product, className, trackName }) => {
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);

  const handleToggleModal = useCallback(() => {
    (async () => {

      setShowModal(!showModal);
      if (!showModal) {
        await reaction({ "type": "Click", "product_id": product.id })
      }
    })();

  }, [showModal]);
  const history = useHistory();

  const goToLink = useCallback((e, link, isAffiliate?) => {
    (async () => {
      e.preventDefault();
      try {
        if (isAffiliate) {
          window.open(link, "_blank") //to open new page        
          var x = await reaction({ "type": "Click", "product_id": product.id })
        } else {
          history.push(link)
          if (trackName) {
            track(trackName)
          }
        }
      } catch (error) {

      }
    })();

  }, []);


  const hasDiscount = product.originalPrice !== product.discountedPrice && product.discountedPrice != 0;
  const discount = hasDiscount
    ? calculateDiscount(product.originalPrice, product.discountedPrice)
    : 0;

  const { currencyCode } = product.currency;

  return (
    <>
    

      <AddToCartModal
        product={product}
        onClose={handleToggleModal}
        onHide={handleToggleModal}

        show={showModal}
      />
      <Paper className={className}>
        <a onClick={(e) => goToLink(e, product.uniqueName, false)} href={product.uniqueName}>
          <div className={classes.header}>
            {/* <Link to={product.uniqueName}> */}
            {/* <div> */}
            <BackgroundImage src={product.photo ? product.photo : "assets/img/placeholder/product_placeholder.jpg"} height="100%" resizeMode="contain" />
            {/* </div> */}

            {/* </Link> */}
            {hasDiscount ? (
              <div className={classes.discountBox}>
                <Text as="span" color="white" bold>
                  {discount}%
                </Text>
              </div>
            ) : null}
            {
              product.business.promotional_text != '' ?
                <div className={classes.promotionalText}>
                  <Text as="span" color="white"> {product.business.promotional_text}</Text>
                </div>
                : null
            }
          </div>
        </a>
        <div className={classes.body}>
          {
            product.is_verified ?
              product.affiliate == "EXTERNAL" || product.affiliate == "INTERNAL" ?
                <Button
                  className={clsx('mr-2', classes.actionBtn)}
                  onClick={e => goToLink(e, product.affiliate == "EXTERNAL" ? product.affiliate_link : product.original_url, true)}
                  color="primary"
                  rounded
                >
                  <Text color='white' as="span" bold capitalized>
                    Buy On {product.business.name}
                  </Text>
                </Button>

                :
                <Button
                  className={clsx('mr-2', classes.actionBtn)}
                  onClick={handleToggleModal}
                  color="primary"
                  rounded
                >
                  <Text color='white' as="span" bold capitalized>
                    Add To Cart
                  </Text>
                </Button>

              : null
          }
          <Link to={product.uniqueName}>
            <Text as="h1" bold className={classes.nameText}>{`${product.name?.slice(0, 75)}${product.name?.length > 75 ? '...' : ''
              }`}</Text>
          </Link>
        </div>
        <div className={classes.footer}>
          <div>
            <Text
              className={clsx(classes.priceText, classes.currentPrice)}
              as="span"
              uppercase
              bold
            >
              {hasDiscount ? product.discountedPrice : product.originalPrice}{' '}
              {product.originalPrice ? currencyCode : null}
            </Text>
            {hasDiscount ? (
              <>
                {/* <Text className={classes.discountText} as="span" bold>
                  {discount}%
              </Text> */}
                <Text
                  className={clsx(classes.priceText, classes.oldPrice)}
                  as="span"
                  uppercase
                  decoration="line-through"
                >
                  {product.originalPrice} {currencyCode}
                </Text>
              </>
            ) : null}
          </div>
          {product.brand ?

            <h5 className={classes.brandName}>
              {/* <Link
                className={classes.link}
                to={`/${product.business.uniqueName}`}
              > */}
              {product.brand.name}
              {/* </Link> */}
            </h5>
            : null
          }
          {product.business.uniqueName ?

            <h5 className={classes.businessName}>
              <Link
                className={classes.link}
                to={`/${product.business.uniqueName}`}
              >
                {product.business.name}
              </Link>
            </h5>
            : null
          }
        </div>
      </Paper>
    </>
  );
};

const useStyles = createUseStyles({
  header: {
    position: 'relative',
    height: '250px',
  },
  discountBox: {
    padding: '5px 10px',
    position: 'absolute',
    bottom: '30px',
    left: '10px',
    borderRadius: '5px',
    backgroundColor: '#522583',
  },
  promotionalText: {
    position: "absolute",
    bottom: "0px",
    backgroundColor: "#522583",
    width: "100%",
    color: "white",
    textAlign: "center"
  },
  cartPlus: {
    fontSize: '21px'
  },
  link: {
    color: '#8D8D8D',
    '&:hover': {
      color: '#6d6c6c',
    },
  },
  body: {
    padding: '10px 20px',
    position: 'relative'
  },
  actionBtn: {
    top: '4px',
    right: '0px',
    flex: 1,
    fontSize: '1rem',
    backgroundColor: '#522583',
    padding: '6px 15px',
    borderRadius: '20px',
    margin: "4px auto !important",
    display: 'block',
    '&:hover': {
      textDecoration: 'none',
    },

  },
  nameText: {
    width: "calc(100%)",
    marginBottom: "0px",
    fontSize: "1rem"
  },
  footer: {
    padding: '0px 20px',
  },
  businessName: {
    color: '#8D8D8D',
    fontWeight: "100",
    fontSize: '0.8rem',
    border: "1px solid #8D8D8D",
    width: "fit-content",
    borderRadius: "4px",
    padding: "6px 5px 4px ",
    marginTop: "10px",
    marginBottom: "20px"
  },
  brandName: {
    color: 'white',
    backgroundColor: "#522583",
    fontWeight: "100",
    fontSize: '0.8rem',
    border: "1px solid #522583",
    width: "fit-content",
    borderRadius: "4px",
    padding: "6px 5px 4px",
    marginTop: "10px"
  },
  priceText: {
    display: 'inline-block',
    marginRight: '10px',
  },
  currentPrice: {
    fontSize: "1.5rem"
  },
  discountText: {
    color: '#522583 !important',
    display: 'inline-block',
    fontSize: "1.4rem",
    marginRight: '10px',
  },
  oldPrice: {
    fontSize: '1.1rem',
    color: "#522583 !important"
  },
});

export default ProductCard;
